import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import { HtmlService } from '../../../../../../services/html.service';
import { LoggerService } from '../../../../../../services/logger.service';
import * as fromRoot from '../../../../../../store/reducers';
import { ConfigHelper } from 'app/services/config.helper';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'media-resource',
    template: require('./media-resource.component.html')
})
export class MediaResourceComponent implements OnInit, OnDestroy {
    @Input() id: number;
    @Input() type: string;
    @Input() autoplay: boolean;
    @ViewChild('audioWrapper') audioWrapper: ElementRef;
    srcUrl: SafeResourceUrl;
    currentProgress: number;
    isPaused: boolean = false;
    infoBoxVisible: boolean;
    infoBoxText: string;
    mediaElement: HTMLMediaElement;
    isExitScreenVisibleSubscription: Subscription;
    performanceNow: number;

    constructor(
        private store: Store<fromRoot.State>,
        private htmlService: HtmlService,
        private loggerService: LoggerService,
        private domSanitizer: DomSanitizer
    ) {
    }

    ngOnInit() {
        this.srcUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.htmlService.getResourceUrl(this.id));
        this.infoBoxVisible = false;
        this.isExitScreenVisibleSubscription = this.store.select(fromRoot.getIsExitScreenVisible).subscribe(isExitScreenVisible => {
            if (isExitScreenVisible) {
                this.isPaused = isExitScreenVisible;
                this.mediaElement.pause();
            } else if (this.isPaused) {
                this.isPaused = isExitScreenVisible;
                this.mediaElement.play();
            }
        });
        this.performanceNow = performance.now();
    }

    ngOnDestroy() {
        if (this.mediaElement && !this.mediaElement.ended) {
            this.mediaElement.pause();
        }

        if (this.isExitScreenVisibleSubscription) {
            this.isExitScreenVisibleSubscription.unsubscribe();
        }
    }

    onPlay(e: Event) {
        this.mediaElement = e.target as HTMLMediaElement;
        if (ConfigHelper.isTdpMode()) {
            this.mediaElement.controls = false;
        }
        this.infoBoxText = "Playing...";
        if (this.type == "audio" && this.autoplay) {
            this.infoBoxVisible = true;
        }
        this.setProgress(e);
    }

    onEnded(e: Event) {
        this.infoBoxText = "Playback finished.";
        this.setProgress(e);
        const timeElapsed = performance.now() - this.performanceNow;
        this.loggerService.reportDebugInfo("MediaResourceComponent", `Duration: ${this.mediaElement.duration} TimeTaken: ${timeElapsed}`);
    }

    onTimeupdate(e: Event) {
        this.setProgress(e);
    }

    onLoadeddata(e: Event) {
        if (!this.autoplay) {
            const media = e.target as HTMLMediaElement;
            media.pause();
            if (this.audioWrapper) {
                this.infoBoxVisible = false;
                (this.audioWrapper.nativeElement as HTMLElement).classList.remove("hidden");
            }
        }
    }

    private setProgress(e: Event) {
        const media = e.target as HTMLMediaElement;
        if (media.currentTime === 0 || media.duration === 0) {
            return 0;
        }
        const newProgress = Math.round((media.currentTime / media.duration) * 100);
        if (newProgress != this.currentProgress) {
            this.currentProgress = newProgress;
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/media-resource/media-resource.component.ts